import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import ArticleCard from '@/components/feature/ArticleCard'
import { articles } from '@/mocks/articles'
import { categories } from '@/mocks/categories'

export default function HotVideosSection() {
  const { t } = useTranslation('common')
  const featured = articles.filter((a) => a.featured)
  const display = featured.slice(0, 3)
  const more = articles.filter((a) => !a.featured).slice(0, 2)
  const displayArticles = [...display, ...more]

  const getCategoryName = (slug: string) =>
    categories.find((c) => c.slug === slug)?.name || slug

  return (
    <section id="hot-videos" className="py-16 md:py-24 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <div className="flex items-end justify-between mb-10 md:mb-14">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
              {t('home.hotVideos')}
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              {t('home.hotVideosSubtitle')}
            </p>
          </div>
          <Link
            to="/category/gaoxiao"
            className="hidden sm:flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            {t('home.viewAll')}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {displayArticles.map((article) => (
            <ArticleCard
              key={article.id}
              id={article.id}
              title={article.title}
              description={article.description}
              thumbnail={article.thumbnail}
              category={article.category}
              categoryName={getCategoryName(article.category)}
              author={article.author}
              views={article.views}
              likes={article.likes}
              date={article.date}
              featured={false}
            />
          ))}
        </div>
      </div>
    </section>
  )
}